export default "__VITE_ASSET__DSsiflT1__"